import { FC, PropsWithChildren } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

type LoaderProps = {
  isLoading: boolean;
};

const LoaderWrapper: FC<PropsWithClassName<PropsWithChildren<LoaderProps>>> = ({
  className,
  isLoading = false,
  children,
}) => {
  return isLoading ? (
    <div className={cn('relative min-h-32 bg-primary bg-opacity-5', className)}>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <ArrowPathIcon className="w-8 h-8 animate-spin" />
      </div>
    </div>
  ) : (
    children
  );
};

export default LoaderWrapper;
